export const eventNames = {
	exportStarting: 'exportStarting',
	exportStarted: 'exportStarted',
	exportCleared: 'exportCleared',
	exportChanged: 'exportChanged',
	exportFailed: 'exportFailed',
	exportCompleting: 'exportCompleting',
	exportCompleted: 'exportCompleted',
	snailySignedIn: 'snailySignedIn',
	snailySignedOut: 'snailySignedOut',
	snailyProfileChanged: 'snailyProfileChanged',
	linkedInSignedOut: 'linkedInSignedOut',
	linkedInProfileDetected: 'linkedInProfileDetected',
	automationScheduleTriggered: 'automationScheduleTriggered',
	automationScheduleDeleted: 'automationScheduleDeleted',
	automationScheduleCreated: 'automationScheduleCreated',
	automationEnded:'automationUpdated',
	extensionUpdating:"extensionUpdating",
	workingHoursChanged:"workingHoursChanged"
} as const